export const PROD: string = 'production';
export const DEV: string = 'develop';
export const PRE: string = 'prepro';

const isPre = () => {
  const INDEX_OF_VALUE = -1;
  const HOST_CI = 'pre.s.shopadvizor.net';

  return window.location.host.indexOf(HOST_CI) !== INDEX_OF_VALUE;
};

const isProd = () => {
  const INDEX_OF_VALUE = -1;
  const PRODUCTION_HOST = 'public.shopadvizor.com';
  const PRODUCTION_HOST_AUX = 'shopadvizor.com.pa';

  return (
    window.location.host.indexOf(PRODUCTION_HOST_AUX) !== INDEX_OF_VALUE ||
    window.location.host.indexOf(PRODUCTION_HOST) !== INDEX_OF_VALUE
  );
};

const getEnvironment = () => {
  if (isProd()) return PROD;
  if (isPre()) return PRE;
  return DEV;
};

const getOAuthUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_OAUTH_URL_PROD;
    case PRE:
      return process.env.REACT_APP_OAUTH_URL_PRE;
    default:
      return process.env.REACT_APP_OAUTH_URL;
  }
};
const getGoogleMaps = () => {
  return process.env.REACT_APP_URL_GOOGLE_MAPS_PROD;
};
const getRawOAuthUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_RAW_OAUTH_URL_PROD;
    case PRE:
      return process.env.REACT_APP_RAW_OAUTH_URL_PRE;
    default:
      return process.env.REACT_APP_RAW_OAUTH_URL;
  }
};

const getGwUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_API_URL_PROD;
    case PRE:
      return process.env.REACT_APP_API_URL_PRE;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

const getSpaUrl = () => {
  const currentEnv = getEnvironment();

  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_SPA_URL_PROD;
    case PRE:
      return process.env.REACT_APP_SPA_URL_PRE;
    default:
      return process.env.REACT_APP_SPA_URL;
  }
};

const getLegacySurveyUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PROD;
    case PRE:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PRE;
    case DEV:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_DEVELOP;
    default:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PRE;
  }
};

const getClientSecret = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CLIENT_SECRET_PROD;
    case PRE:
      return process.env.REACT_APP_CLIENT_SECRET_PRE;
    default:
      return process.env.REACT_APP_CLIENT_SECRET;
  }
};

const getClientSecretForLoginUser = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CLIENT_SECRET_USER_PROD;
    case PRE:
      return process.env.REACT_APP_CLIENT_SECRET_USER_PRE;
    default:
      return process.env.REACT_APP_CLIENT_SECRET_USER;
  }
};
const getClientSecretForLoginAdmin = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CR_CLIENT_SECRET_PROD;
    case PRE:
      return process.env.REACT_APP_CR_CLIENT_SECRET_PRE;
    default:
      return process.env.REACT_APP_CR_CLIENT_SECRET;
  }
};
const getEnv = () => {
  if (isProd()) {
    return 'production';
  }
  if (isPre()) {
    return 'prepro';
  }

  return 'develop';
};
const getEdition = () => 'saz-pa';

const getGoogleClientId = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CREDENTIALS_CLIENT_GOOGLE_ID_PROD;
    case PRE:
      return process.env.REACT_APP_CREDENTIALS_CLIENT_GOOGLE_ID_PRE;
    default:
      return process.env.REACT_APP_CREDENTIALS_CLIENT_GOOGLE_ID;
  }
};

export {
  getOAuthUrl,
  getGwUrl,
  getLegacySurveyUrl,
  getClientSecret,
  getRawOAuthUrl,
  getSpaUrl,
  getGoogleMaps,
  getClientSecretForLoginUser,
  getClientSecretForLoginAdmin,
  getEnv,
  getEnvironment,
  getEdition,
  getGoogleClientId,
};
